var _circle, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoSymbol(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_190_825",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 21,
    height: 21
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10.0409,
    cy: 10.4434,
    r: 10,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_190_825)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 13.0409,
    y: -2.22314,
    width: 1,
    height: 12.6665,
    rx: 0.5,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 7.04089,
    y: -2.22314,
    width: 1,
    height: 7,
    rx: 0.5,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 11.0409,
    y: -2.22314,
    width: 1,
    height: 8.6665,
    rx: 0.5,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 5.04089,
    y: -2.22314,
    width: 1,
    height: 5,
    rx: 0.5,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 15.0409,
    y: -2.22314,
    width: 1,
    height: 11,
    rx: 0.5,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 9.04089,
    y: -2.22314,
    width: 1,
    height: 6,
    rx: 0.5,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 17.0409,
    y: -2.22314,
    width: 1,
    height: 10,
    rx: 0.5,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 19.0409,
    y: -2.22314,
    width: 1,
    height: 12,
    rx: 0.5,
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5305 9.94523C22.8221 9.88011 23.0893 10.1472 23.0241 10.4388C22.4608 12.961 22.148 16.4783 20.3546 18.2718C18.5611 20.0653 15.0439 20.3781 12.5217 20.9415C12.2301 21.0066 11.963 20.7395 12.0281 20.4479C12.5914 17.9257 12.9042 14.4084 14.6977 12.6149C16.4912 10.8214 20.0084 10.5086 22.5305 9.94523Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.96983 3.37225C1.09446 5.24761 0.0408934 7.79115 0.0408939 10.4433C0.0408936 13.0955 1.09446 15.639 2.96983 17.5144C4.84519 19.3897 7.38873 20.4433 10.0409 20.4433C12.6931 20.4433 15.2366 19.3897 17.112 17.5144L10.0409 10.4433L2.96983 3.37225Z",
    fill: "black"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoSymbol);
export default __webpack_public_path__ + "static/media/logoSymbol.cef18c123532e91c18507ffdf7ef4ef4.svg";
export { ForwardRef as ReactComponent };